export type IFactory<T extends Record<string, unknown>> = T & {
    init: () => Promise<void>;
};

export default function Factory<T extends Record<string, unknown>>(modules: Record<keyof T, (resolve: T) => T[keyof T]>): IFactory<T> {
    const resolutions = {} as T;

    const resolve = new Proxy({} as T, {
        get: (_target, key: string) => {
            if (resolutions[key]) return resolutions[key];
            else resolutions[key as keyof T] = modules[key](resolve);
            return resolutions[key];
        },
    });

    for (const module of Object.keys(modules)) {
        if (resolutions[module]) continue;
        resolutions[module as keyof T] = modules[module](resolve);
    }

    const init = async () => {
        await Promise.all(
            Object.values(resolutions).map((resolution) => {
                // @ts-ignore - avoid breaking the application
                if (typeof resolution?.onInit === "function") return resolution.onInit();
                return Promise.resolve();
            }),
        );
    };

    return { ...resolutions, init };
}
